import React, { Component } from 'react';
import classNames from 'classnames'

import {LangChangeEventContext} from '../../contexts/LangContext';
import MyLink from '../MyLink';
import MyLinkOut from '../MyLinkOut';
import MyIcons from '../MyIcons';

import styles from './index.css';

export default class PAA extends Component {
  render() {
    return ( 
      <LangChangeEventContext.Consumer>
      {({lang}) =>(
         <div className={classNames(styles['index'], this.props.classStyle, styles[this.props.colorStyle])} >
          <div className={styles['linkWrSolo']}>
            <MyIcons icon={this.props.iconPlace} width='15px' height='21px'/>
            <div className={styles['textWrapper']} >

              <MyLinkOut classStyle={styles['linkSolo']} to="https://yandex.ru/maps/-/CBB8VSTcpB">
                <div className={styles['text']} >
                  {lang.t('adress')}
                </div>
              </MyLinkOut>

              <MyLink classStyle={styles['linkSolo']} to="/contacts?scroll=true">
                <div className={styles['textUnderline']} >
                  {lang.t('viewContacts')}
                </div>
              </MyLink>

            </div>
          </div>
          <MyLinkOut classStyle={styles['link']} to={"tel:"+lang.t('contactsPhoneLink')}>
            <MyIcons icon={this.props.iconPhone} width='15px' height='22px'/>
            <div className={styles['textWrapper']} >
              <div className={styles['text']} >
                {lang.t('phoneFor')}
              </div>
              <div className={styles['textPhone']} >
                {lang.t('contactsPhoneV')}
              </div>
            </div>
          </MyLinkOut>
         </div>
      )}
      </LangChangeEventContext.Consumer>
    );
  }
}
  



// WEBPACK FOOTER //
// ./src/blocks/PhoneAndAddress/index.js